export class Command{
	command: string;
	data: any;
}